export default __webpack_public_path__ + "static/fti_2-141e55c0fe5c655ddcdb10e52d261a3e.webp";